/**
 * Tek kaynak: NEXT_PUBLIC_API_URL (frontend/.env.local)
 * Örn: http://192.168.2.18:3001 veya https://haberapi.test
 *
 * SSR için opsiyonel: API_INTERNAL_URL=http://127.0.0.1:3001
 * (LAN IP'ye Node bağlanamazsa ECONNREFUSED önler)
 */
const ENV_API_BASE_URL = (
  process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001'
).replace(/\/$/, '')

function isPrivateHostname(hostname: string): boolean {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname)
  )
}

/** SSR / RSC — mümkünse loopback; tarayıcı LAN IP kullanmaya devam eder */
function resolveServerApiBaseUrl(): string {
  const internal = (process.env.API_INTERNAL_URL || '').trim().replace(/\/$/, '')
  if (internal) return internal

  try {
    const url = new URL(ENV_API_BASE_URL)
    if (isPrivateHostname(url.hostname) && url.hostname !== '127.0.0.1' && url.hostname !== 'localhost') {
      return `${url.protocol}//127.0.0.1${url.port ? `:${url.port}` : ''}`
    }
  } catch {
    // ignore invalid env URL
  }

  return ENV_API_BASE_URL
}

/** HTTPS sayfada (haber.test) HTTP API → mixed content; Caddy proxy kullan */
export function getApiBaseUrl(): string {
  if (typeof window === 'undefined') return resolveServerApiBaseUrl()

  try {
    const env = new URL(ENV_API_BASE_URL)
    const pageHost = window.location.hostname
    const pageProto = window.location.protocol

    // HTTPS page + HTTP API → Caddy / production proxy
    if (pageProto === 'https:' && env.protocol === 'http:') {
      if (pageHost === 'haber.test' || pageHost.endsWith('.haber.test')) {
        return 'https://haberapi.test'
      }
    }

    // localhost sayfa + LAN IP API → AYNI hostname (localhost≠127.0.0.1;
    // cross-site sayılır, SameSite=Lax cookie auth kırılır)
    if (
      (pageHost === 'localhost' || pageHost === '127.0.0.1') &&
      isPrivateHostname(env.hostname) &&
      env.hostname !== pageHost
    ) {
      return `${env.protocol}//${pageHost}${env.port ? `:${env.port}` : ''}`
    }

    // Sayfa başka LAN IP'deyse (ör. 192.168.2.12) API'yi aynı host + env port ile dene
    if (
      pageProto === 'http:' &&
      isPrivateHostname(pageHost) &&
      pageHost !== 'localhost' &&
      pageHost !== '127.0.0.1' &&
      isPrivateHostname(env.hostname) &&
      pageHost !== env.hostname
    ) {
      return `${env.protocol}//${pageHost}${env.port ? `:${env.port}` : ''}`
    }
  } catch {
    // ignore invalid env URL
  }

  return ENV_API_BASE_URL
}

/**
 * İstemci istekleri — tarayıcıda getApiBaseUrl() kullanın.
 * Sabit ENV değeri SSR / proxy için kalır; client fetch'lerde getApiBaseUrl tercih edilir.
 */
export const API_BASE_URL = ENV_API_BASE_URL

/** SSR / sunucu tarafı istekler — loopback tercih edilir */
export const API_SERVER_BASE_URL = resolveServerApiBaseUrl()
export const API_SERVER_URL = `${API_SERVER_BASE_URL}/api`

/** İstemci bundle'da getApiBaseUrl() ile HTTPS proxy; SSR'da env URL */
export const API_URL = `${getApiBaseUrl()}/api`

export function getApiUrl(): string {
  return `${getApiBaseUrl()}/api`
}
